import samsung from '../images/logos/samsung.jpeg'
import scp from '../images/logos/scp.png'
import chaibazaar from '../images/logos/chaibazaar.jpeg'
import honeywell from '../images/logos/honeywell.jpeg'
import chegg from '../images/logos/chegg.jpeg'
import powstik from '../images/logos/powstik.jpeg'
import accenture from '../images/logos/accenture.png'
import aihyr from '../images/logos/aihyr.png'
import wellsfargo from '../images/logos/wellsfargo.jpeg'
export const experience = [
	{
		id: 11,
		role: 'Software Engineer',
		company: 'Wells Fargo',
		type: 'Full-time',
		location: 'Hyderabad, India',
		date: 'Sep 2025 - Present',
		logo: wellsfargo,
		description: [
			'Led a team of 6 engineers to architect and deliver a multi-agent release automation platform using Google ADK and FastMCP, reducing manual release effort by 80% and significantly improving release governance, compliance, and audit readiness.',
			'Spearheaded development of resilient, high-availability APIs using idempotency, retries, circuit breakers, and structured logging; orchestrated 4 downstream systems for data enrichment, claim creation, and resolution.',
			'Led monolith-to-microservices migration of a private label credit card transaction system using the Strangler Pattern to enable gradual modernization and service decoupling.',
			'Migrated 7+ production components from PCF to OpenShift, modernizing the deployment platform, improving scalability and resilience, and enabling standardized CI/CD pipelines.'
		],
	},
	{
		id: 10,
		role: 'Program Associate',
		company: 'Wells Fargo',
		type: 'Full-time',
		location: 'Hyderabad, India',
		date: 'Aug 2024 - Sep 2025',
		logo: wellsfargo,
		description: [
			'Led and built a CLI-based utility to streamline Change Request creation, Jira workflows, deployments, and automated performance test script generation, reducing developer friction by 70–80% and standardizing release workflows across teams.',
			'Designed and implemented scalable event-driven microservices architecture for PayOn Loan originations using Spring Boot and Kafka, powering intake, prequalification, fraud detection, and pricing workflows.',
			'Architected resilient APIs using idempotency, retry mechanisms, circuit breakers, and structured logging, reducing failure rates by 35%.',
			'Optimized API testing pipeline using Karate Framework, integrated with Harness and HyperExecute for parallel test execution, reducing manual QA effort by 60% and improving reliability.',
			'Improved code quality & test coverage from 50% to 90%+ reducing cognitive complexity and eliminating code smells.'
		]
	},
	{
		id: 9,
		role: 'Technology Analyst',
		company: 'Wells Fargo',
		type: 'Internship',
		location: 'Hyderabad, India',
		date: 'Feb 2024 - Jul 2024',
		logo: wellsfargo,
		description: [
			'Identified recurring production incidents caused by configuration drift and release mismatches between UAT and Production environments across 12+ engineering teams.',
			'Designed and launched a centralized Release Readiness Dashboard integrating GitHub, TFS, Harness, UCD, and JIRA for real-time cross-system release validation.',
			'Automated aggregation of release evidence, configuration drift detection, and embedded security (ThreadFix) and code quality (Sonar) gates directly into the release workflow.',
			'Validated 50+ releases per month across the LOB, reducing release-related incidents by 95%, cutting manual release validation effort by 50%, and shortening release preparation time by 30%.',
			'Adopted across the LOB as a mandatory pre-production release gate, strengthening governance, risk controls, and cross-team release transparency.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1OgTyFaSopwlbPhuZPQcon0O8WhT_aZIz/view?usp=sharing'
		}
	},
	{
		id: 8,
		role: 'Founding Software Engineer',
		company: 'AI.HYR',
		type: 'Internship',
		location: 'Remote',
		date: 'Aug 2023 - Feb 2024',
		logo: aihyr,
		description: [
			'Architected and launched an end-to-end AI-driven recruitment platform as the Founding Engineer, partnering directly with the CEO and CTO to take the product from 0 → production. Enabled companies to scale hiring operations with minimal recruiter intervention, supporting 5000+ interviews and coding assessments per month.',
			'Designed and implemented a Retrieval-Augmented Generation (RAG) pipeline to auto-generate role-specific job descriptions and interview questions, ingest resumes from LinkedIn and Naukri, and automate candidate shortlisting — significantly accelerating the hiring funnel and reducing manual recruiter touchpoints by 80%.',
			'Built an LLM-powered resume screening and interview evaluation system leveraging rubric-grounded scoring and GPT-based explainable reports. Implemented asynchronous evaluation workflows with cloud-based audio storage, Whisper transcription, and LLM-as-a-Judge scoring — reducing interview turnaround time by 40% while improving hiring consistency and transparency.',
			'Engineered scalable system architecture with MongoDB-backed evaluation pipelines, background job processing, bulk scheduling automation, Judge0-powered multi-language coding tests, and fault-tolerant retry mechanisms — ensuring high availability, audit-ready decision trails, and near-zero interview disruptions at scale.',
			'Contributed to early customer adoption and operational efficiency gains, lowering recruitment costs by ~30% and improving hiring throughput for growing startup clients.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1JTS8f8I9Oe_QEst-2XYXZ3Jmlq2KPkVa/view?usp=sharing'
		}
	},
	{
		id: 7,
		role: 'Advanced App Engineering Analyst',
		company: 'Accenture',
		type: 'Internship',
		location: 'Remote',
		date: 'Jun 2023 - Jul 2023',
		logo: accenture,
		description: [
			'Contributed to an AWS Security-focused project aimed at strengthening cloud infrastructure governance and secure resource management for enterprise clients.',
			'Worked hands-on with core AWS services including EC2, S3, IAM, Lambda, and RDS, implementing secure configurations and best practices aligned with cloud security standards.',
			'Assisted in analyzing IAM role policies, access control mechanisms, and storage security configurations to ensure least-privilege access and compliance readiness.',
			'Supported automation initiatives using serverless components to improve operational efficiency and monitoring.',
			'Conducted in-depth research on Quantum Computing and Post-Quantum Cryptography (PQC), delivering a technical knowledge session on emerging cryptographic risks and future-ready encryption strategies.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1QRjqmK7gR3YTxS-2f_8ecYa6b749IrqK/view?usp=drive_link'
		}
	},
	{
		id: 1,
		role: 'Research Intern',
		company: 'Samsung R&D Institute India',
		type: 'Internship',
		location: 'Remote',
		date: 'Dec 2022 - Jun 2023',
		logo: samsung,
		description: [
			'Developed a Transport Capsule utilizing Government’s APIsetu APIs for Bixby, enhancing conversational experiences.',
			'Gained in-depth knowledge of the Bixby Ecosystem, Samsung’s innovative voice assistant platform.',
			'Collaborated with cross-functional teams to leverage existing APIs for improved user interaction.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1oXOGpoV7V0tdNhWKX_-aB0qvmythSyMm/view?usp=sharing'
		}
	},
	{
		id: 2,
		role: 'Full Stack Developer',
		company: 'Spark Consultancy Pro',
		type: 'Internship',
		location: 'Remote',
		date: 'Jun 2022 - Nov 2022',
		logo: scp,
		description: [
			'Deployed and maintained websites on Amazon Web Services (AWS), ensuring high availability and performance.',
			'Developed and maintained web applications using the MERN stack, enhancing user experience and functionality.',
			'Created a custom WhatsApp API to facilitate real-time communication of website form responses to clients.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1CNZjc15dZ61QJ30qL874mcEdX6QqGOLX/view?usp=drive_link'
		}
	},
	{
		id: 3,
		role: 'Android Developer',
		company: 'ChaiBaazaar',
		type: 'Internship',
		location: 'Remote',
		date: 'Sep 2021',
		logo: chaibazaar,
		description: [
			'Led the development and maintenance of an Android app from inception to launch.',
			'Implemented application logic using Java and Android Studio, leveraging MVVM architecture.',
			'Developed engaging UI/UX for application modules utilizing Material UI principles.'
		],
		link: {
			text: 'View Certificate',
			url: 'https://drive.google.com/file/d/1TUjcpZyGF1DZmOf-jvvc31sj2ciiXjjv/view?usp=sharing'
		}
	}
]
